module.exports = __webpack_public_path__ + "media/images/games/k2gender/basketballplayer-e704a0ae167185d5982cbbf72350dba4.png";